import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { changeMonthToDayDate, format_date_simple } from "../../../../helpers/api";

import BranchStep1 from "./branches/step1";
import BranchStepLandlord from "./branches/step-landlord";
import BranchStep2 from "./branches/step2";
import BranchStep3 from "./branches/step3";
import BranchStep4 from "./branches/step4";

export default function AddBranchForm({
  changeStep,
  step,
  amenities,
  isFormProcessing,
  handleBranch,
  branch_row,
  states,
}) {
  const [is_new_account, setIs_new_account] = useState(false)

  const {
    register,
    handleSubmit,
    control,
    setValue,
    trigger,
    watch,
    reset,
    formState: { errors, isValid },
  } = useForm({ mode: "all" });
  const watchAllFields = watch();
  const onSubmit = (data) => {
    let amenities = null;

    if (
      data?.amenities !== undefined &&
      data?.amenities !== null &&
      data?.amenities !== "" &&
      data?.amenities?.length > 0
    ) {
      amenities = data?.amenities;
    }
    let newData = {
      ...data,
      amenities: amenities,
      is_new_account: is_new_account ? 'yes' : 'no',
      landlord_dob: changeMonthToDayDate(data?.landlord_dob),
    };
    handleBranch(newData);
  };
  console.log(branch_row)
  useEffect(() => {
    setValue("landlord_first_name", branch_row?.landlord_first_name);
    setValue("landlord_middle_name", branch_row?.landlord_middle_name);
    setValue("landlord_last_name", branch_row?.landlord_last_name);
    setValue(
      "landlord_dob",
      branch_row?.landlord_dob
        ? format_date_simple(branch_row?.landlord_dob, "MM-DD-YYYY")
        : ""
    );
    setValue("landlord_phone", branch_row?.landlord_phone || "");
    setValue("landlord_address_line1", branch_row?.landlord_address_line1);
    setValue("landlord_address_line2", branch_row?.landlord_address_line2);
    setValue("landlord_city", branch_row?.landlord_city);
    setValue("landlord_state", branch_row?.landlord_state);
    setValue("landlord_zip_code", branch_row?.landlord_zip_code);
    setValue("address_line1", branch_row?.address_line1);
    setValue("address_line2", branch_row?.address_line2);
    setValue("city", branch_row?.city);
    setValue("state", branch_row?.state);
    setValue("zip_code", branch_row?.zip_code);
    setValue("property_type", branch_row?.property_type);
    setValue("house_style", branch_row?.house_style);
    setValue("amenities", branch_row?.amenities);
    if(branch_row?.routing_number && branch_row?.account_title && branch_row?.account_type){
      setValue("account_number", branch_row?.account_number);
      setValue("routing_number", branch_row?.routing_number);
      setValue("account_title", branch_row?.account_title);
      setValue("account_type", branch_row?.account_type);
    }
    else{
      setIs_new_account(true)
    }
    
  }, [branch_row]);
  let property_options = [
    {
      label: "Single Family",
      value: "Single Family",
    },
    {
      label: "Townhouse",
      value: "Townhouse",
    },
    {
      label: "Condo",
      value: "Condo",
    },
    {
      label: "Apartment",
      value: "Apartment",
    },
    {
      label: "Duplex",
      value: "Duplex",
    },
    {
      label: "Other",
      value: "Other",
    },
  ];

  let house_style_options = [
    {
      label: "Craftsman",
      value: "Craftsman",
    },
    {
      label: "Ranch",
      value: "Ranch",
    },
    {
      label: "Tudor",
      value: "Tudor",
    },
    {
      label: "Victorian",
      value: "Victorian",
    },
    {
      label: "Colonial",
      value: "Colonial",
    },
    {
      label: "Federal",
      value: "Federal",
    },
    {
      label: "Italianate",
      value: "Italianate",
    },
  ];

  return (
    <>
      <form action="" method="POST" onSubmit={handleSubmit(onSubmit)}>
        {step === 0 ? (
          <BranchStep1
            step={step}
            changeStep={changeStep}
            errors={errors}
            register={register}
            branch_row={branch_row}
            isValid={isValid}
            trigger={trigger}
            states={states}
            control={control}
            watchAllFields={watchAllFields}
          />
        ) : step === 1 ? (
          <BranchStepLandlord
            step={step}
            changeStep={changeStep}
            errors={errors}
            register={register}
            control={control}
            branch_row={branch_row}
            isValid={isValid}
            trigger={trigger}
            states={states}
          />
        ) : step === 2 ? (
          <BranchStep3
            step={step}
            changeStep={changeStep}
            errors={errors}
            register={register}
            branch_row={branch_row}
            isValid={isValid}
            trigger={trigger}
            watchAllFields={watchAllFields}
          />
        ) : step === 3 ? (
          <BranchStep2
            step={step}
            changeStep={changeStep}
            errors={errors}
            register={register}
            branch_row={branch_row}
            isFormProcessing={isFormProcessing}
            property_options={property_options}
            house_style_options={house_style_options}
            amenities={amenities}
            control={control}
            trigger={trigger}
            isValid={isValid}
            watchAllFields={watchAllFields}
            setValue={setValue}
          />
        ) : step === 4 ? (
          <BranchStep4
            step={step}
            changeStep={changeStep}
            errors={errors}
            register={register}
            branch_row={branch_row}
            isFormProcessing={isFormProcessing}
            property_options={property_options}
            house_style_options={house_style_options}
            amenities={amenities}
            control={control}
            trigger={trigger}
            isValid={isValid}
            watchAllFields={watchAllFields}
            setValue={setValue}
            setIs_new_account={setIs_new_account}
            is_new_account={is_new_account}
            reset={reset}
            watch={watch}
          />
        ) : (
          ""
        )}
      </form>
    </>
  );
}
